import { render, staticRenderFns } from "./AppLayoutAluno.vue?vue&type=template&id=a480917c&scoped=true"
import script from "./AppLayoutAluno.vue?vue&type=script&lang=js"
export * from "./AppLayoutAluno.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutAluno.vue?vue&type=style&index=0&id=a480917c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a480917c",
  null
  
)

export default component.exports